import { useMemo } from 'react';
import { ReviewPoResponse } from 'src/services/useReviewPoApi';
import { code } from '../GetColor';

export interface validationType {
  message: string;
  type: code;
}

const defaultValidationMessage: validationType = {
  message: 'fetching...',
  type: 'loading',
};
const usePoValidationMessage = (
  poNumber: string,
  reviewPoValidations: ReviewPoResponse,
  isReviewPoLoading: boolean,
  initialLoading: boolean,
  reviewPoError: string | null
) => {
  const poValidationMessage = useMemo(() => {
    let poValidationMessage = defaultValidationMessage;

    const poMatchStatus = reviewPoValidations.matchStatus;
    if (isReviewPoLoading || initialLoading) {
      return (poValidationMessage = defaultValidationMessage);
    }
    if (reviewPoError) {
      return (poValidationMessage = { message: '', type: 'loading' });
    }
    if (!poNumber) {
      if (reviewPoValidations.isPoRequiredToCreateInvoice) {
        poValidationMessage = { message: 'PO # is required.', type: 'error' };
      } else {
        poValidationMessage = { message: 'PO # not provided. Enter if available.', type: 'warning' };
      }
    } else if (poNumber.length < 5) {
      poValidationMessage = { message: 'PO # must be at least 5 characters.', type: 'warning' };
      if (reviewPoValidations.isPoRequiredToCreateInvoice) {
        poValidationMessage.type = 'error';
      }
    } else {
      if (poMatchStatus === 'MultipleMatch') {
        poValidationMessage = {
          message: 'Multiple possible matches found for PO #.',
          type: 'warning',
        };
        if (reviewPoValidations.isPoRequiredToCreateInvoice) {
          poValidationMessage.type = 'error';
        }
      } else if (
        poMatchStatus === 'ConfirmedMatchCreatedByCurrentUser' ||
        poMatchStatus === 'ConfirmedMatchCreatedByOtherUser'
      ) {
        if (
          (poMatchStatus === 'ConfirmedMatchCreatedByOtherUser' &&
            !reviewPoValidations.canReceiveInvoicesCompany) ||
          (poMatchStatus === 'ConfirmedMatchCreatedByCurrentUser' &&
            !reviewPoValidations.canReceiveInvoices)
        ) {
          poValidationMessage = {
            message: 'You do not have permission to create docs for this PO.',
            type: 'error',
          };
        } else {
          poValidationMessage = { message: 'PO # is confirmed.', type: 'success' };
        }
      } else if (poMatchStatus === 'InvalidMatch') {
        poValidationMessage = {
          message:
            'PO # is a match for invalid PO (PO is new, closed, cancelled, submitted, no access or exists in other company).',
          type: 'warning',
        };
        if (reviewPoValidations.isPoRequiredToCreateInvoice) {
          poValidationMessage.type = 'error';
        }
      } else if (poMatchStatus === 'NoMatch' || poMatchStatus === 'PoNumberNotFound') {
        poValidationMessage = { message: 'No matches found for PO #.', type: 'warning' };
        if (reviewPoValidations.isPoRequiredToCreateInvoice) {
          poValidationMessage.type = 'error';
        }
      } else {
        poValidationMessage = { message: 'fetching...', type: 'loading' };
      }
    }

    return poValidationMessage;
  }, [
    initialLoading,
    isReviewPoLoading,
    poNumber,
    reviewPoError,
    reviewPoValidations.canReceiveInvoices,
    reviewPoValidations.canReceiveInvoicesCompany,
    reviewPoValidations.isPoRequiredToCreateInvoice,
    reviewPoValidations.matchStatus,
  ]);

  return poValidationMessage;
};

export default usePoValidationMessage;
